import { combineReducers } from "redux";

import contentHubReducer from "@/content-hub/store/reducer";
import authenticationReducer from "@/features/authentication/authentication-reducer";
import customFontsReducer from "@/features/custom-fonts/custom-fonts-reducer";
import eventAuthReducer from "@/features/event-auth-details/event-auth-details-reducer";
import recordingsReducer from "@/features/recordings/recordings-reducer";
import relatedEventsReducer from "@/features/related-events/related-events-reducer";
import requestsReducer from "@/features/requests/requests-reducer";
import schedulesReducer from "@/features/schedules/schedules-reducer";
import speakersReducer from "@/features/speakers/speakers-reducer";
import sponsorsReducer from "@/features/sponsors/sponsors-reducer";
import textCustomizationsReducer from "@/features/text-customizations/text-customizations-reducer";
import userReducer from "@/features/user/user-reducer";
import vendorsReducer from "@/features/vendors/vendors-reducer";

const rootReducer = combineReducers({
  requests: requestsReducer,
  authentication: authenticationReducer,
  contentHub: contentHubReducer,
  user: userReducer,
  speakers: speakersReducer,
  sponsors: sponsorsReducer,
  schedules: schedulesReducer,
  vendors: vendorsReducer,
  customFonts: customFontsReducer,
  eventAuth: eventAuthReducer,
  recordings: recordingsReducer,
  textCustomizations: textCustomizationsReducer,
  relatedEvents: relatedEventsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
